var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"page-user-view"}},[_c('page-title',{attrs:{"title":_vm.title}}),_c('card-full',{attrs:{"data":_vm.info,"dataStructure":_vm.getDataStructureInChunk,"showDeleteBtn":_vm.showDeleteBtn,"showEditBtn":_vm.showEditBtn,"showCancelBtn":_vm.showCancelBtn,"endPoint":_vm.endPoint,"editPage":_vm.editPage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }